import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d24147ba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24147ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d24147ba')) {
      api.createRecord('d24147ba', component.options)
    } else {
      api.reload('d24147ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d24147ba&scoped=true&", function () {
      api.rerender('d24147ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/zaiko/index.vue"
export default component.exports